import { Link } from 'react-router-dom';

import { Button, Card, CardContent, CardDescription, CardHeader, CardTitle } from '@dymaxion/ui';

export function NotFoundPage() {
  return (
    <Card className="w-full max-w-md text-center">
      <CardHeader>
        <CardTitle className="text-5xl font-light">404</CardTitle>
        <CardDescription className="mt-2 text-base">
          The page you&apos;re looking for isn&apos;t here.
        </CardDescription>
      </CardHeader>
      <CardContent>
        <Button asChild>
          <Link to="/">Back to sign in</Link>
        </Button>
      </CardContent>
    </Card>
  );
}
